
export const UserRolesMap = {
  admin: "Admin",
  ea: "Extension Agent",
  "content-manager": "Content Manager",
  "report-consumer": "Report Consumer",
  marketer: "Marketer"
}
